import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TimeService } from 'src/app/time.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pre-shipment-modals',
  templateUrl: './pre-shipment-modals.component.html',
  styleUrls: ['./pre-shipment-modals.component.scss']
})
export class PreShipmentModalsComponent implements OnInit {

  pendingAcceptance: any = [];
  pendingAssignment: any = [];
  consentStatusData: any = [];
  driverAcceptanceData: any = [];
  countryCode: any = '';

  consentHeaders: any = ['sin', 'driver', 'assignedTime'];
  driverHeaders: any = ['sin', 'driver', 'assignedTime'];

  constructor(private dialog: MatDialogRef<PreShipmentModalsComponent>, @Inject(MAT_DIALOG_DATA) public parentData: any,
              private timeService: TimeService, private router: Router) { }

  ngOnInit() {

    const country = JSON.parse(localStorage.getItem('carriers'));
    this.countryCode = country[0].country.country_code || '';

    if (this.parentData.type == 0) {
      this.pendingAcceptance = this.parentData.details || [];
    } else if (this.parentData.type == 1) {
      this.pendingAssignment = this.parentData.details || [];
    } else if (this.parentData.type == 2) {
      (this.parentData.details) ? '' : this.parentData.details = [];

      this.parentData.details.forEach(element => {
        const temp: any = {};

        temp.SIN = element.SIN;
        temp.driver = element.driver;
        temp.assignedTime = (element.created_at) ? this.getDate(element.created_at) : 'N/A';
        this.consentStatusData.push(temp);
      });

    } else if (this.parentData.type == 3) {
      (this.parentData.details) ? '' : this.parentData.details = [];

      this.parentData.details.forEach(element => {
        const temp: any = {};

        temp.SIN = element.SIN;
        temp.driver = element.driver;
        temp.assignedTime = (element.created_at) ? this.getDate(element.created_at) : 'N/A';
        this.driverAcceptanceData.push(temp);
      });
    }
  }

  closeModal(data = '') {
    this.dialog.close(data);
  }

  getDate(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }

  getDuration(value) {
    return (value) ? this.timeService.getDurationFromNow(value) : 'N/A';
  }

  openDashboard(ev: Event, mode, type) {
    this.closeModal();
    this.router.navigateByUrl(`dashboard/${mode}/${type}`);
    ev.stopPropagation();
  }

}
